var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.986,
    height: 17.998,
    viewBox: "0 0 17.986 17.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23087",
    "data-name": "Path 23087",
    d: "M12.08,2.307a2.308,2.308,0,0,0-4.16,0L1.28,15.367A2.468,2.468,0,0,0,3.359,19H16.638a2.469,2.469,0,0,0,2.08-3.63ZM10,6.726a.818.818,0,0,1,.818.818v4.09a.818.818,0,0,1-1.636,0V7.544A.818.818,0,0,1,10,6.726Zm0,6.953a.818.818,0,0,1,.818.818v.409a.818.818,0,1,1-1.636,0V14.5A.818.818,0,0,1,10,13.679Z",
    transform: "translate(-1.006 -0.998)",
    fill: "#f36300",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationAlert);
export default __webpack_public_path__ + "static/media/verification-alert.e63a05989288316e7e48c586e6f0144b.svg";
export { ForwardRef as ReactComponent };